import React, { useState } from "react";
import { useMenuToggler } from "hooks/useMenuToggler";
import { useNavigate } from "react-router-dom";
import { IRoutesProps } from "types";
import plusIcon from "assets/icons/add-icon.svg";
import minusIcon from "assets/icons/minus-icon.svg";

export default function Navlink({
  icon,
  label,
  path,
  inactiveIcon,
  isActive,
  showLabel,
  hasSubRoute,
  subRoute = [],
  shouldShow,
}: IRoutesProps) {
  const [isHovered, setIsHovered] = useState(false);
  const [isSubRouteOpen, setIsSubRouteOpen] = useState(false);
  const [openSubRoute, setOpenSubRoute] = useState<string | null>(null);

  const navigate = useNavigate();
  const { closeMenu } = useMenuToggler();

  const handleNavigate = (targetPath: string) => {
    navigate(targetPath);
    closeMenu();
  };

  const toggleSubRoute = (path: string) => {
    setOpenSubRoute((prev) => (prev === path ? null : path));
  };

  return (
    <div className="w-full">
      <button
        onClick={() => {
          if (hasSubRoute) {
            setIsSubRouteOpen((prev) => !prev);
          } else {
            handleNavigate(path);
          }
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className={`relative flex w-full items-center justify-between font-medium text-sm rounded leading-[20.3px] text-[#101928] p-[8px_16px] hover:bg-[#B9F2FF] ${
          isActive ? "bg-[#B9F2FF]" : ""
        }`}
        // disabled={}
      >
        <div className="flex items-center gap-2 ">
          <div className="h-[40px] w-[40px] flex items-center justify-center group relative">
            <img
              src={isActive || isHovered ? icon : inactiveIcon}
              alt={label + " icon"}
            />
            {!showLabel && (
              <span
                className="absolute left-[50px] bg-[#101928] text-white text-xs rounded-lg py-1 px-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50"
                style={{ whiteSpace: "nowrap" }}
              >
                {label}
              </span>
            )}
          </div>

          {showLabel && (
            <span
              className={`${
                isActive ? "text-[#101928] text-sm" : "text-[#667185]"
              } z-50`}
            >
              {label}
            </span>
          )}
        </div>

        {hasSubRoute && showLabel && (
          <img
            src={isSubRouteOpen ? minusIcon : plusIcon}
            alt="arrow toggle"
            className={`transition-transform duration-300`}
          />
        )}
      </button>

      {/* Subroutes */}
      {hasSubRoute && isSubRouteOpen && subRoute.length > 0 && (
        <div className="ml-8 mt-2 flex flex-col gap-2">
          {subRoute.map((sub, index) => (
            <div key={index} className="w-full">
              <button
                onClick={() =>
                  sub.hasChildren
                    ? toggleSubRoute(sub.path)
                    : handleNavigate(sub.path)
                }
                className={`flex items-center justify-between text-sm font-medium rounded p-[8px_16px] w-full ${
                  sub.isActive
                    ? "bg-[#B9F2FF] text-[#101928]"
                    : "text-[#667185]"
                } hover:bg-[#B9F2FF]`}
              >
                <span>{sub.label}</span>
                {sub.hasChildren && (
                  <img
                    src={openSubRoute === sub.path ? minusIcon : plusIcon}
                    alt="toggle children"
                    className={`transition-transform duration-300`}
                  />
                )}
              </button>

              {/* Child Routes */}
              {sub.hasChildren && openSubRoute === sub.path && (
                <div className="ml-8 mt-2 flex flex-col gap-2 w-full">
                  {sub.children?.map((child, childIndex) => (
                    <button
                      key={childIndex}
                      onClick={() => handleNavigate(child.path)}
                      className={`flex items-center text-sm font-medium rounded p-[8px_16px] w-full ${
                        child.isActive
                          ? "bg-[#B9F2FF] text-[#101928]"
                          : "text-[#667185]"
                      } hover:bg-[#B9F2FF]`}
                    >
                      <span className="">{child.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
